import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
export function useAriaBusyScroll(host) {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== host) {
    t0 = () => {
      if (!host) {
        return;
      }
      const onscroll = function onscroll() {
        if (!host) {
          return;
        }
        host.setAttribute("aria-busy", "true");
        host.addEventListener("scrollend", onscrollend, {
          once: true
        });
      };
      function onscrollend() {
        if (!host) {
          return;
        }
        host.setAttribute("aria-busy", "false");
        host.addEventListener("scroll", onscroll, {
          once: true
        });
      }
      host.addEventListener("scroll", onscroll, {
        once: true
      });
      host.addEventListener("scrollend", onscrollend);
      return () => {
        host.removeEventListener("scroll", onscroll);
        host.removeEventListener("scrollend", onscrollend);
      };
    };
    t1 = [host];
    $[0] = host;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}